export enum RouteParamsEnum {
  DEAL_ID = 'dealId',

  PROPERTY_INDEX = 'propertyIndex',
  PROFILE_ID = 'profileId',
}
